import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import { TextPropTypes, Text } from "@towersystems/roam-common-native";
import RetailerPayType from "../../utilities/data/model/RetailerPayType";

const UNKNOWN = "Unknown";

export type RetailerPayTypeIdToNameProps = TextPropTypes & {
  retailerPayTypeId: string;
};

export const RetailerPayTypeIdToName = ({
  retailerPayTypeId,
  ...props
}: RetailerPayTypeIdToNameProps) => {
  const [name, setName] = React.useState<string | undefined>(undefined);
  const database = useDatabase();

  React.useEffect(() => {
    (async () => {
      try {
        const payType = await database
          .get<RetailerPayType>("retailer_pay_types")
          .find(retailerPayTypeId);

        setName(payType.payDescription ?? UNKNOWN);
      } catch (err) {
        setName(UNKNOWN);
      }
    })();
  }, [retailerPayTypeId]);

  if (!name) {
    return null;
  }

  return <Text {...props}>{name}</Text>;
};
